const CaptchaFamily = {
	VISUAL: 'Visual',
	AUDIO: 'Audio'
};

export default CaptchaFamily;
